module.exports = __webpack_public_path__ + "images/roundedThumbLight.734d684a.webp";